import {createAction} from '@reduxjs/toolkit'

export const updateChat = createAction('chat/save', (data) => ({
  payload: data
}))
